export const getPhotosDesc = (value) => {
  let desc = ""
  if (value === "Paper") {
    desc =
      "Choosing paper photos ensures you have high quality photos inserted into your locket, and allows you to change or update your photos at any time."
  } else if (value === "Metal") {
    desc =
      "Your photos will be printed on sterling silver and permanently inserted in your locket using a waterproof, scratch-proof seal for a beautiful, fade-resistant keepsake."
  }
  return desc
}
